import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT } from "../data/gear";

export const Footer = ({ onQuote }) => {
  return (
    <footer data-testid="footer" className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <div className="mb-5">
            <img
              src="/av30a-logo.jpg"
              alt="AV30A — Audio Visual Equipment Rentals, 30A Emerald Coast"
              className="h-20 w-auto object-contain rounded-lg bg-white p-2"
            />
          </div>
          <p className="text-sm text-primary-foreground/70 max-w-xs leading-relaxed">
            Audio visual production gear and beach rentals along the Emerald Coast. Full setup &amp; teardown included on every order.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-accent mb-5">Service Area</h4>
          <ul className="space-y-2 text-sm text-primary-foreground/80">
            {CONTACT.serviceAreas.map((a) => (
              <li key={a} className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-accent" /> {a}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-accent mb-5">Get in Touch</h4>
          <div className="space-y-3 text-sm">
            <a href={CONTACT.phoneHref} data-testid="footer-phone" className="flex items-center gap-2 hover:text-accent transition-colors">
              <Phone className="w-4 h-4" /> {CONTACT.phone}
            </a>
            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-2 hover:text-accent transition-colors break-all">
              <Mail className="w-4 h-4" /> {CONTACT.email}
            </a>
            <button
              data-testid="footer-quote-btn"
              onClick={onQuote}
              className="mt-3 px-5 py-2.5 rounded-full bg-accent text-accent-foreground text-xs font-semibold uppercase tracking-widest hover:bg-accent/90 transition-colors"
            >
              Request a Quote
            </button>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-foreground/60">
          <p>© {new Date().getFullYear()} AV30A. All rights reserved.</p>
          <div className="flex gap-5">
            <Link to="/corporate-events" className="hover:text-accent">Corporate Events</Link>
            <Link to="/corporate-av" className="hover:text-accent">Wedding AV</Link>
            <Link to="/beach-gear" className="hover:text-accent">Beach Gear</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
